<template>
  <div>
    <es-loader
      v-if="loading"
      style="margin: 1rem"
    />
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="Transaction not found."
    />
    <div v-else>
      <div>
        <es-profile-header>
          <template #profile-header>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="header-title">
                    Transaction Profile
                  </div>
                  <div class="header-subtitle">
                    Contains one or many records.
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #profile-overview v-if="transaction.profileHeader">
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ transaction.profileHeader.id }}
                  </div>
                  <div class="column-subtitle">
                    Transaction ID
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    <div>
                      {{ transaction.profileHeader.submissionType }}
                    </div>
                    <div
                      v-if="transaction.profileHeader.submissionType === 'File'"
                      class="max-width" style="margin: auto"
                    >
                      ({{ transaction.profileHeader.fileName }})
                    </div>
                  </div>
                  <div class="column-subtitle">
                    Submission Type
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ transaction.profileHeader.processInfo | formatDateMMDDYYYYHHMM }}
                  </div>
                  <div class="column-subtitle">
                    Process Info
                  </div>
                </div>
              </div>
              <div class="column" v-if="transaction.dmBatchId">
                <div class="column-content">
                  <router-link
                    v-if="hasModule('DRMCH:MATCH:HISTORY:VIEW')"
                    :to="{ path: `/directMatch/batch/${transaction.dmBatchId}/details` }"
                    class="has-text-weight-bold" style="font-size: 18px;"
                  >
                    {{ transaction.dmBatchId }}
                  </router-link>
                  <span v-else class="column-title text--align">
                    {{ transaction.dmBatchId }}
                  </span>
                  <div class="column-subtitle">
                    Related Batch
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="status-box" style="width: fit-content; margin: auto;">
                    <dm-status-info-icon
                      :matchStatus="transaction.dmTransStatus"
                    />
                  </div>
                  <div class="column-subtitle">
                    Status
                  </div>
                </div>
              </div>
            </div>
          </template>
        </es-profile-header>
        <div class="tabs-container">
          <div class="tabs no-bottom-border">
            <ul>
              <li v-if="hasModule('DRMCH:MATCH:HISTORY:VIEW')"
                :class="{ 'is-active': this.$route.name === 'DMTransactionInfoDetails' }"
              >
                <router-link
                  :to="{ name: 'DMTransactionInfoDetails' }"
                >
                  DETAILS
                </router-link>
              </li>
              <li v-if="hasModule('DRMCH:DWNLD:DOWNLOAD')"
                :class="{ 'is-active': this.$route.name === 'DMTransactionInfoDownload' }"
              >
                <router-link
                  :to="{ name: 'DMTransactionInfoDownload' }"
                >
                  DOWNLOAD
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <router-view :transaction="transaction"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleLeft,
} from '@fortawesome/pro-regular-svg-icons';
import DmStatusInfoIcon from '@/components/DmStatusInfoIcon.vue';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAngleDoubleLeft,
);
export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
  ],
  components: {
    DmStatusInfoIcon,
    EsException,
    EsLoader,
    EsProfileHeader,
  },
  props: [
    'transactionId',
  ],
  data() {
    return {
      loading: true,
      loadingError: null,
      transaction: null,
    };
  },
  created() {
    this.loadTransaction();
  },
  mounted() {
    this.setBreadcrumbs();
  },
  computed: {
    ...mapGetters([
      'hasProgramPermission',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
  methods: {
    ...mapActions([
      'getTransaction',
    ]),
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'directMatch' } },
        { text: 'Processing Information ', to: {} },
      ]);
    },
    getCategory(value) {
      let matchType = {};
      const matches = [1,14,16].forEach(code => matchType[code] = 'Match / No Match (Completed)');
      const noMatches = [4,15].forEach(code => matchType[code] = 'Match / No Match (Completed)');
      const canceled = [13, 17].forEach(code => matchType[code] = 'Canceled (Completed)');
      const nearMatch = [2].forEach(code => matchType[code] = `Ready to Resolve ${this.properties['SYSTEM_LABEL-NEARMATCH']}(s/es) (Pending)`);
      // Near Match (es)
      return matchType[value];
    },
    methFormatDateMMDDYYYYHH(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY HH:mm A');
      }
      return 'N/A';
    },
    async loadTransaction() {
      try {
        this.loading = true;
        await this.getTransaction(this.transactionId).then((response) => {
        this.transaction = response.data;
        if(this.transaction)
          if(this.transaction.dmBatch) {
            if(!this.transaction.dmBatch.matchStats) {
              this.transaction.dmBatch.matchStats = new Array(0);
              if(this.transaction.dmTransStatus) {
                this.transaction.dmTransStatus.matchStatusDesc = this.transaction.dmTransStatus.description;
                this.transaction.dmTransStatus.matchStatusCode = this.transaction.dmTransStatus.code;
                this.transaction.dmTransStatus.statType = this.transaction.dmTransStatus.code;
                this.transaction.dmTransStatus.matchDate = this.methFormatDateMMDDYYYYHH(this.transaction.profileHeader.processInfo);
                this.transaction.dmTransStatus.count = 1;
                this.transaction.dmBatch.recordCount = 1;
                this.transaction.dmTransStatus.userMatchCount = 1;
                this.transaction.dmTransStatus.userNoMatchCount = 1;
                this.transaction.dmTransStatus.userCancelCount = 1;
                this.transaction.dmTransStatus.userNearMatchCount = 1;
                this.transaction.dmBatch.matchStats.push(this.transaction.dmTransStatus);
              }
            }
          }
        });
      } catch (error) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    transactionPermission(permission) {
      return {
        permission,
        districtCode: this.transaction.districtCode,
        schoolCode: this.transaction.schoolCode,
        programCode: this.transaction.programCode,
      };
    },
  },
};
</script>
  <style lang="sass" scoped>
    .margin-bottom
      margin-bottom: 1rem
    .progress-bar
      height: 5px
      width: 75px
      margin-bottom: 3px
      margin-left: 1rem
    .max-width
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      max-width: 20ch
  </style>
